import React from "react";
import { Award, Briefcase, Heart } from "lucide-react";

const CommitmentSection = () => {
  const commitments = [
    {
      icon: <Award className="w-12 h-12 text-blue-600" />,
      title: "Professional Reliability",
      description: "Count on our team for consistent quality, punctuality, and transparent practices — building trust through dependable results every time.",
      image: "https://images.unsplash.com/photo-1638976892251-efab1145436a?auto=format&fit=crop&w=600"
    },
    {
      icon: <Briefcase className="w-12 h-12 text-blue-600" />,
      title: "Complete Solutions",
      description: "From start to finish, we handle everything with efficiency and care, ensuring your project is delivered smoothly and exceeds expectations.",
      image: "https://images.unsplash.com/photo-1770086962001-3da4f60e7db5?auto=format&fit=crop&w=600"
    },
    {
      icon: <Heart className="w-12 h-12 text-blue-600" />,
      title: "Personalized Attention",
      description: "We value every client, providing attentive service, clear communication, and solutions designed to fit your specific needs.",
      image: "https://images.pexels.com/photos/15060419/pexels-photo-15060419.jpeg?auto=compress&cs=tinysrgb&w=600"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block">
            <div className="h-1 w-16 bg-blue-600 mb-4 mx-auto"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">Our Commitment to Quality</h2>
        </div>

        {/* Commitments */}
        <div className="space-y-12">
          {commitments.map((commitment, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-8 items-center ${
                index % 2 === 1 ? "lg:flex-row-reverse" : ""
              }`}
            >
              <div className={index % 2 === 1 ? "lg:order-2" : ""}>
                <img
                  src={commitment.image}
                  alt={commitment.title}
                  className="w-full h-80 object-cover rounded-lg shadow-lg"
                />
              </div>
              <div className={index % 2 === 1 ? "lg:order-1" : ""}>
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    {commitment.icon}
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold mb-4 text-gray-900">{commitment.title}</h3>
                    <p className="text-lg text-gray-600 leading-relaxed">{commitment.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CommitmentSection;